export const TEXT_POSITION_OPTIONS = [
    { label: "center", value: "center" },
    { label: "left", value: "left" },
    { label: "right", value: "right" },
];